<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="pa-3">
        <csv-etiquetas-crud />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CsvEtiquetasCrud from './CsvEtiquetasCrud'
export default {
  name: 'CsvEtiquetasPage',
  components: { CsvEtiquetasCrud }
}
</script>
